import { Box } from '@mui/material';
import {
  getGridDateOperators,
  getGridStringOperators,
  GridColDef,
} from '@mui/x-data-grid-pro';

import { EllipsisTooltip } from '@/components';
import { excludeValues, formatDate } from '@/components/DataGrid/utils';
import { IUser } from '@/models';
import { IInmateNote } from '@/pages/JMS/Managament/types/inmate';
import { formatPersonName } from '@/utils';

const description = (): Partial<GridColDef> => ({
  renderCell: (params: {
    colDef: { computedWidth: number };
    row: IInmateNote;
  }) => {
    return (
      <Box
        sx={{
          width: params.colDef.computedWidth - 10,
          display: 'flex',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <EllipsisTooltip style={{ fontSize: '0.875rem' }}>
          {params?.row?.description || ''}
        </EllipsisTooltip>
      </Box>
    );
  },
});

const officer = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IInmateNote }) =>
    formatPersonName(params?.row?.officer as IUser),
  valueGetter: (_, row) => row.officer.fullName,
  filterOperators: getGridStringOperators().filter(
    excludeValues(['isEmpty', 'isNotEmpty', 'isAnyOf']),
  ),
});

const createdBy = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IInmateNote }) =>
    formatPersonName(params?.row?.createdBy as IUser),
  valueGetter: (_, row) => row.createdBy.fullName,
  filterOperators: getGridStringOperators().filter(
    excludeValues(['isEmpty', 'isNotEmpty', 'isAnyOf']),
  ),
});

const createdAt = (): Partial<GridColDef> => ({
  renderCell: (params) => formatDate(params.row.createdAt),
  filterOperators: getGridDateOperators(true).filter(
    excludeValues(['isNotEmpty', 'isEmpty']),
  ),
});

export const inmateNoteCols = () => {
  return {
    description,
    officer,
    createdBy,
    createdAt,
  };
};
